import { useContext } from 'react'
import { PageContext } from '@/contexts/page-context'

export function usePageContext() {
  const context = useContext(PageContext)

  if (!context) {
    throw new Error('usePageContext deve ser usado dentro de PageProvider')
  }

  return context
}
